export default "__VITE_ASSET__Cqj$93vm__"